// import React from "react";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";

// function SuperGeoFence() {
//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox p={3}>
//         <MDTypography variant="h4">Super GeoFence Page</MDTypography>
//         <MDTypography mt={2}>Here you can manage all GeoFence data.</MDTypography>
//       </MDBox>
//     </DashboardLayout>
//   );
// }

// export default SuperGeoFence;
import React from "react";
import MDBox from "components/MDBox";

import SetSuperGeofence from "./supergeofence";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
function SuperGeoFence() {
  return (
    <DashboardLayout>
      <DashboardNavbar/>
      <MDBox sx={{ display: "flex", justifyContent: "center" }}>
        <SetSuperGeofence />
      </MDBox>
    </DashboardLayout>
  );
}

export default SuperGeoFence;